<template>
  <div class="page rd">
    <Header />

    <section class="hero">
      <div class="hero-overlay">
        <div class="wrapper">
          <div class="left">
            <div class="navigation">首页 > 解决方案 > <span v-if="navigationAddName">{{ navigationAddName }} > </span>方案详情</div>
            <div class="title">
              {{ title }}
            </div>
          </div>
          <div class="operations">
            <p class="operations-item" v-if="pre" @click="toPre">
              <img src="../static/soluction/pre.png" alt="" />
              上一方案
            </p>
            <p class="operations-item" v-if="next" @click="toNext">
              <img src="../static/soluction/next.png" alt="" />
              下一方案
            </p>
            <p class="operations-item" @click="toList">
              <img src="../static/soluction/list.png" alt="" />
              返回列表
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section intro">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">方案简介</div>
          <div class="tag"></div>
        </h2>

        <div class="intro_details">
          <!-- <div class="line">
            <div class="dot"></div>
            <div class="txt">
              {{ intro }}
            </div>
          </div> -->
          <div class="line">
            <div class="txt txt_with_style">
              {{ intro }}
            </div>
          </div>
          <!-- <div class="line">
            <div class="dot"></div>
            <div class="txt">
              双面微晶技术的应用可以让电池片透光性更好、导电性更佳，有效提升异质结电池的光电转换效率。
            </div>
          </div>
          <div class="line">
            <div class="dot"></div>
            <div class="txt">
              凭借持续不断的自主研发，星翰科技率先实现了异质结电池整线装备的国产化。最新一代整体解决方案单线年产能达1.2GW，完整覆盖了异质结电池生产的四道工序，通过大片化、薄片化、半片化制程，
              结合创新PECVD双面微晶工艺路线，集成整线MES智能片级追踪系统，提升太阳能电池的转换效率、
              良率、产能，同时降低生产成本。
            </div>
          </div>
          <div class="line">
            <div class="dot"></div>
            <div class="txt">
              双面微晶技术的应用可以让电池片透光性更好、导电性更佳，有效提升异质结电池的光电转换效率。
            </div>
          </div> -->
          <img :src="img" alt="" />
        </div>
      </div>
    </section>

    <section class="section feature">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">方案特点</div>
          <div class="tag"></div>
        </h2>
        <div class="list">
          <div class="item" v-for="(item,index) in features" :key="index">
            <div class="icon"></div>
            <div class="txt">
              {{ item }}
            </div>
          </div>
          <!-- <div class="item">
            <div class="icon"></div>
            <div class="txt">
              2. 搭配密栅图形设计，用低银含浆料替代纯银浆料，不损失电池片性能；
            </div>
          </div>
          <div class="item">
            <div class="icon"></div>
            <div class="txt">
              3.
              印刷窗口宽，兼容10μm及以下丝网印刷，满足钢网印刷；印刷窗口宽，兼容10μm及以下丝网印刷，满足钢网印刷；印刷窗口宽，兼容10μm及以下丝网印刷，满足钢网印刷；印刷窗口宽，兼容10μm及以下丝网印刷，
              满足钢网印刷；
            </div>
          </div> -->
        </div>
      </div>
    </section>

    <section class="section like">
      <div class="section-container">
        <h2 class="title">
          <div class="txt">产品列表</div>
          <div class="tag"></div>
        </h2>
        <div class="product_pc">
          <el-carousel :interval="5000" arrow="always" height="276px" indicator-position="none" :autoplay="true">
            <el-carousel-item v-for="(item,index) in productSplit" :key="index">
              <div class="custom">
                <div class="items">
                  <div class="item" v-for="(product, idx) in item" :key="idx"  @click="openDialog(product)">
                    <img :src="product.img" alt="" />
                    <div class="product">
                      <div class="product_name">{{ product.name }}</div>
                      <div class="product_desc">
                        {{ product.description }}
                      </div>
                      <div class="btn">了解更多 >></div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="product_mobile">
          <el-carousel :interval="500000" arrow="always" height="126px" indicator-position="none" :autoplay="true">
            <el-carousel-item v-for="(item, index) in products" :key="index">
              <div class="custom">
                <div class="items">
                  <div class="item" @click="openDialog(item)">
                    <img :src="item.img" alt="" />
                    <div class="product">
                      <div class="product_name">{{ item.name }}</div>
                      <div class="product_desc text-ellipsis-two">
                        {{ item.description }}
                      </div>
                      <div class="btn">了解更多 >></div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <contactModule />
    <Footer />


    <!-- 弹窗 -->
    <div class="dialog_masker" v-if="showDialog">
      <div class="dialog_content">
        <div class="close_icon" @click="showDialog = false"></div>
        <div class="header">
          <div class="left left_pc">
            <el-carousel :interval="500000" arrow="always" height="363px" indicator-position="none" :autoplay="true">
              <el-carousel-item v-for="item in productImgs" :key="item">
                <div class="custom">
                  <img :src="item" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="left left_mobile">
            <el-carousel :interval="500000" arrow="always" height="203px" indicator-position="none" :autoplay="true">
              <el-carousel-item v-for="item in productImgs" :key="item">
                <div class="custom">
                  <img :src="item" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <div class="title">
              {{ productName }}
              <span>分类：{{ categoryName }}</span>
              <span></span>
            </div>
            <div class="sub_title">应用范围</div>
            <p>{{ applicationScope }}</p>
            <div class="sub_title">产品特性</div>
            <div class="line" v-for="(item, index) in descs" :key="index">
              <div class="dot"></div>
              <div class="txt">{{ item }}</div>
            </div>
            <!-- <div class="line">
              <div class="dot"></div>
              <div class="txt">分散性好</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">收缩率小</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">填充性好</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">导电性好</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">烧损低</div>
            </div>
            <div class="line">
              <div class="dot"></div>
              <div class="txt">烧损低</div>
            </div> -->
          </div>
        </div>
        <div class="body">
          <div class="sub_title">产品规格</div>
          <el-table :data="tableData" stripe style="width: 100%" :border="true"
            :header-cell-style="{ background: '#0248FF', color: '#fff' }" :cell-style="tableRowStyle">
            <el-table-column 
              v-for="(headItem,index) in tableHead" 
              :key="index"
              align="center" 
              :prop="headItem.id" 
              :label="headItem.name"
            >
              <el-table-column 
                v-for="(item,idx) in (headItem.item || [])" 
                :key="idx"
                align="center" 
                :prop="item.id" 
                :label="item.name"
              >
              </el-table-column>
            </el-table-column>

            <!-- <el-table-column align="center" prop="prop" label="规格型号"></el-table-column>
            <el-table-column align="center" prop="prop1" label="平均粒径(μm)"></el-table-column>

            <el-table-column align="center" prop="prop2" label="激光粒度粒径分布(μm)">
              <el-table-column align="center" prop="prop3" label="D97"></el-table-column>
              <el-table-column align="center" prop="prop4" label="D97"></el-table-column>
              <el-table-column align="center" prop="prop5" label="D97"></el-table-column>
              <el-table-column align="center" prop="prop6" label="D97"></el-table-column>
            </el-table-column>
            <el-table-column align="center" prop="prop7" label="比表面积(m2/g)"></el-table-column>
            <el-table-column align="center" prop="prop8" label="振实密度(g/cm3)"></el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import contactModule from "../components/contactModule.vue";
import { SolutionAPI } from "../api/api";
import { imgBaseUrl } from "../api/config";


export default {
  name: "News",
  components: {
    Header,
    Footer,
    contactModule,
  },

  // 实现当前页切换新闻
  watch: {
    // 监听路由参数变化
    '$route.params.id': {
      immediate: true,
      handler(newId, oldId) {
        if(!newId){
          return
        }
        if (newId !== oldId) {
          this.getPageData()
        }
      }
    }
  },
  
  computed: {
    productSplit() {
      return this.splitArray(this.products, 2);
    },
  },
  data() {
    return {
      tableHead: [],
      tableData: [],
      showDialog: false,

      title: '',
      intro: '',
      img: '',
      features: [],
      products: [],
      pre: null,
      next: null,

      productImgs: [],
      productName: '',


      categoryName: '',
      applicationScope: '',
      descs: [],
    };
  },

  methods: {
    getPageData() {
      SolutionAPI.getSolutionDetail(this.$route.params.id).then((res) => {
        console.log("解决方案详情", res);
        this.title = res.title
        this.intro = res.summary
        this.img = res.image ? `${imgBaseUrl}${res.image}` : ''
        this.features = res.features
        this.navigationAddName = res.categoryName ? res.categoryName === '太阳能光伏' ? '光伏新能源' : res.categoryName : ''
        this.products = (res.products || []).map(item => {
          return {
            ...item,
            img: item.coverImage ? `${imgBaseUrl}${item.coverImage}` : ''
          }
        })
        this.pre = res.previousSolution
        this.next = res.nextSolution
      });
    },
    toPre() {
      this.$router.replace(`/solutions/${this.pre.id}`);
    },
    toNext() {
      this.$router.replace(`/solutions/${this.next.id}`);
    },
    toList() {
      this.$router.back()
    },

    splitArray(arr, size) {
      if (!arr.length || size <= 0) return [];
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        const chunk = arr.slice(i, i + size);
        result.push(chunk);
      }
      return result;
    },
    tableRowStyle({ row, column, rowIndex, columnIndex }) {
      // 隔行换色设置为红色
      if (rowIndex % 2 === 0) {
        return { backgroundColor: "#ffffff" }; // 浅灰色
      } else {
        return { backgroundColor: "#ECF3FD" }; // 浅红色
      }
    },
    openDialog(item) {
      SolutionAPI.getProductDetail(item.id).then((res) => {
        console.log("产品详情", res);
        this.productName = res.name
        this.categoryName = res.categoryName
        this.productImgs = res.images.map(item => {
          return `${imgBaseUrl}${item.imageUrl}`
        })
        console.log(999666,this.productImgs);

        this.applicationScope = res.applicationScope
        this.descs = res.features ? res.features.split('\n') : []

        let tableHead = res.specParamsStructure ? JSON.parse(res.specParamsStructure) : []
        this.tableHead = tableHead
        let tableData = res.specParamsValue ? JSON.parse(res.specParamsValue) : []
        console.log('tableHead', tableHead);
        console.log('tableData', tableData);
        this.tableData = tableData.map(itemArr => {
          let obj = {}
          itemArr.forEach((attrObj)=>{
            if(attrObj.item){
              attrObj.item.forEach(itemObj => {
                obj[itemObj.paramId] = itemObj.value
              })
            }else{
              obj[attrObj.paramId] = attrObj.value
            }
          })
          return obj
        })
        this.showDialog = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
// pc
@media (min-width: 751px) {
  .section {
    padding-bottom: 100px;

    .section-container {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
    }
  }

  .hero {
    position: relative;
    height: 580px;
    background: url("../static/soluction/detail_head_bg.png") center/cover no-repeat;

    .hero-overlay {
      max-width: 1400px;
      min-width: 1400px;
      margin: 0 auto;
      padding: 0 40px;
      overflow: hidden;

      .wrapper {
        display: flex;
        align-items: center;
        margin-top: 225px;
        gap: 282px;

        .left {
          flex: 1;

          .navigation {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
          }

          .title {
            margin-top: 40px;
            font-weight: 600;
            font-size: 40px;
            color: #fff;
            line-height: 50px;
          }
        }

        .operations {
          width: 260px;

          .operations-item {
            display: flex;
            align-items: center;
          }

          p {
            cursor: pointer;
            padding: 22px;
            font-size: 16px;
            color: #fff;
            border-top: 1px solid #f7f8fa;
            border-bottom: 1px solid #f7f8fa;

            img {
              width: 18px;
              height: 18px;
              margin-right: 26px;
            }

            // &:nth-child(2) {
            //   border: none;
            // }
          }

          .operations-item+.operations-item {
            border-top: none;
          }

          // p:hover {
          //   color: #0248FF;
          // }
        }
      }
    }
  }

  .feature,
  .intro,
  .like {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 72px;

      .txt {
        font-weight: 600;
        font-size: 40px;
        color: #363636;
      }

      .tag {
        margin-top: 24px;
        width: 24px;
        height: 3px;
        background: #0248ff;
      }
    }
  }

  .feature {
    .list {
      display: flex;
      flex-direction: column;
      gap: 24px;

      .item {
        display: flex;
        align-items: center;
        padding: 22px 40px;
        background: #f9fafc;
        border-radius: 8px;

        .icon {
          flex-shrink: 0;
          width: 50px;
          height: 50px;
          // background: url('../static/solution/star.png');
          background: url("../static/soluction/star.png");
          margin-right: 28px;
        }

        .txt {
          font-size: 14px;
          color: #888888;
        }
      }

      .item:hover {
        background: #ecf1ff;
      }
    }
  }

  .like {
    padding-top: 100px;
    background: #ecf1ff;

    /deep/.el-carousel__arrow--left {
      left: 0px !important;
    }

    /deep/.el-carousel__arrow--right {
      right: 0px !important;
    }

    .product_pc {
      display: block;
    }

    .product_mobile {
      display: none;
    }

    .custom {
      height: 100%;

      .items {
        margin: 0 50px;
        height: 100%;
        display: flex;
        align-items: center;
        gap: 14px;

        .item {
          max-width: 50%;
          flex: 1;
          cursor: pointer;
          display: flex;
          align-items: stretch;
          background: #ffffff;
          border-radius: 8px;
          overflow: hidden;

          img {
            // width: 370px;
            height: 276px;
          }

          .product {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 36px 50px 22px 28px;
            line-height: 1;

            .product_name {
              margin-bottom: 15px;
              font-size: 26px;
              color: #000000;
              font-weight: bold;
            }

            .product_desc {
              font-size: 14px;
              color: #4c4c4c;
              line-height: 20px;
            }

            .btn {
              margin-top: auto;
              margin-left: auto;
              font-size: 14px;
              color: #0248ff;
            }
          }
        }
      }
    }
  }

  .intro {
    padding-top: 100px;

    .intro_details {
      margin-top: 72px;

      .line {
        display: flex;
        align-items: flex-start;

        .dot {
          margin-top: 10px;
          flex-shrink: 0;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background-color: #888;
          margin-right: 8px;
        }

        .txt {
          font-size: 14px;
          color: #888888;
          line-height: 26px;

          span {
            font-weight: 600;
            color: #0248ff;
          }
        }
      }

      img {
        margin-top: 56px;
        width: 100%;
      }
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .dialog_masker {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 99999;

    .dialog_content {
      position: relative;
      width: 80%;
      padding: 54px;
      background: #fff;

      /deep/.el-carousel__arrow--right {
        background: rgba(255, 255, 255, 0.8);
        color: #0248ff;
      }

      /deep/.el-carousel__arrow--left {
        background: rgba(255, 255, 255, 0.8);
        color: #0248ff;
      }

      .header {
        display: flex;
        align-items: flex-start;
        gap: 90px;

        .left_pc {
          display: block;
        }

        .left_mobile {
          display: none;
        }

        .left {
          flex-shrink: 0;
          width: 483px;

          .custom {
            height: 100%;
            border-radius: 16px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .right {
          flex: 1;

          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 26px;
            color: #000000;
            font-weight: bold;

            span {
              font-size: 14px;
              color: #888888;
              font-weight: normal;
            }
          }

          .sub_title {
            line-height: 28px;
            margin-top: 20px;
            font-size: 16px;
            color: #0248ff;
            font-weight: bold;
          }

          .line {
            display: flex;
            align-items: flex-start;

            .dot {
              margin-top: 10px;
              flex-shrink: 0;
              width: 4px;
              height: 4px;
              border-radius: 100%;
              background-color: #888;
              margin-right: 8px;
            }

            .txt {
              font-size: 14px;
              color: #888888;
              line-height: 30px;

              span {
                font-weight: 600;
                color: #0248ff;
              }
            }
          }
        }
      }

      .body {
        .sub_title {
          padding: 34px 0 20px;
          text-align: center;
          font-size: 16px;
          color: #0248ff;
          font-weight: bold;
        }
      }
    }

    .close_icon {
      position: absolute;
      right: 16px;
      top: 16px;
      width: 15px;
      height: 15px;
      background: url("../static/job/close.png") center/cover no-repeat;
    }
  }

  /deep/.el-table {
    border: none;

    td {
      border: none;
    }
  }

  /deep/ .el-table::before,
  /deep/ .el-table::after {
    display: none;
  }
}

// mobile
@media (max-width: 750px) {
  .section {
    padding-bottom: 50px;

    .section-container {
      padding: 0 24px;
    }
  }

  .hero {
    position: relative;
    height: 229px;
    background: url("../static/soluction/detail_head_bg.png");
    background-size: 100% 100%;

    .hero-overlay {
      padding-top: 55px;

      .wrapper {
        display: flex;
        align-items: center;
        // margin-top: 225px;
        // gap: 282px;

        .left {
          flex: 1;
          padding: 0 24px;

          .navigation {
            display: none;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
          }

          .title {
            margin-top: 60px;
            font-weight: 600;
            font-size: 20px;
            color: #fff;
            line-height: 25px;
          }
        }

        .operations {
          display: none;
          width: 260px;

          .operations-item {
            display: flex;
            align-items: center;
          }

          p {
            cursor: pointer;
            padding: 22px;
            font-size: 16px;
            color: #fff;
            border-top: 1px solid #f7f8fa;
            border-bottom: 1px solid #f7f8fa;

            img {
              width: 18px;
              height: 18px;
              margin-right: 26px;
            }

            &:nth-child(2) {
              border: none;
            }
          }

          // p:hover {
          //   color: #0248FF;
          // }
        }
      }
    }
  }

  .feature,
  .intro,
  .like {
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 36px;

      .txt {
        font-weight: 600;
        font-size: 20px;
        color: #363636;
      }

      .tag {
        margin-top: 12px;
        width: 12px;
        height: 2px;
        background: #0248ff;
      }
    }
  }

  .feature {
    .list {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .item {
        display: flex;
        align-items: center;
        padding: 11px 20px;
        background: #f9fafc;
        border-radius: 8px;

        .icon {
          flex-shrink: 0;
          width: 25px;
          height: 25px;
          // background: url('../static/solution/star.png');
          background: url("../static/soluction/star.png");
          background-size: 100% 100%;
          margin-right: 14px;
        }

        .txt {
          font-size: 12px;
          color: #888888;
        }
      }
    }
  }

  .like {
    padding-top: 50px;

    .section-container {
      padding-left: 12px;
      padding-right: 12px;
    }

    background: #ecf1ff;

    /deep/.el-carousel__arrow--left {
      left: 0px !important;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(255, 255, 255, 0.4);
    }

    /deep/.el-carousel__arrow--right {
      right: 0px !important;
      width: 24px;
      height: 24px;
      color: #0248ff;
      background: rgba(255, 255, 255, 0.4);
    }

    .product_pc {
      display: none;
    }

    .product_mobile {
      display: block;
    }

    .custom {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      .items {
        margin: 0 26px;
        height: 100%;
        display: flex;
        align-items: center;
        // gap: 14px;

        .item {
          cursor: pointer;
          display: flex;
          align-items: stretch;
          background: #ffffff;
          border-radius: 8px;
          overflow: hidden;

          img {
            height: 126px;
            // width: 160px;
            // object-fit: contain;
          }

          .product {
            min-width: 117px;
            display: flex;
            flex-direction: column;
            padding: 18px 25px 11px 14px;
            line-height: 1;

            .product_name {
              margin-bottom: 8px;
              font-size: 13px;
              color: #000000;
              font-weight: bold;
            }

            .product_desc {
              font-size: 12px;
              color: #4c4c4c;
            }

            .btn {
              margin-top: auto;
              margin-left: auto;
              font-size: 12px;
              color: #0248ff;
            }
          }
        }
      }
    }
  }

  .intro {
    padding-top: 50px;

    .intro_details {
      margin-top: 36px;

      .line {
        display: flex;
        align-items: flex-start;

        .dot {
          margin-top: 10px;
          flex-shrink: 0;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background-color: #888;
          margin-right: 8px;
        }

        .txt {
          font-size: 12px;
          color: #888888;
          line-height: 18px;

          span {
            font-weight: 600;
            color: #0248ff;
          }
        }
      }

      img {
        margin-top: 28px;
        width: 100%;
      }
    }
  }

  .text-ellipsis-two {
    line-height: 1.5;
    height: 3em;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .dialog_masker {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 99999;

    .dialog_content {
      max-height: 80vh;
      overflow: auto;
      position: relative;
      width: calc(100% - 48px);
      padding: 24px;
      background: #fff;

      /deep/.el-carousel__arrow--right {
        width: 24px;
        height: 24px;
        color: #0248ff;
        background: rgba(236, 241, 255, 1);
      }

      /deep/.el-carousel__arrow--left {
        width: 24px;
        height: 24px;
        color: #0248ff;
        background: rgba(236, 241, 255, 1);
      }

      .header {
        display: flex;
        flex-direction: column;
        gap: 30px;

        .left_pc {
          display: none;
        }

        .left_mobile {
          display: block;
        }

        .left {
          width: 100%;

          .custom {
            height: 100%;
            border-radius: 8px;
            overflow: hidden;

            img {
              // width: 100%;
              // height: 100%;
            }
          }
        }

        .right {
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            color: #000000;
            font-weight: bold;

            span {
              font-size: 12px;
              color: #888888;
              font-weight: normal;
            }
          }

          .sub_title {
            line-height: 16px;
            margin-top: 10px;
            margin-bottom: 5px;
            font-size: 12px;
            color: #0248ff;
            font-weight: bold;
          }

          p {
            font-size: 12px;
          }

          .line {
            display: flex;
            align-items: flex-start;

            .dot {
              margin-top: 15px;
              flex-shrink: 0;
              width: 2px;
              height: 2px;
              border-radius: 100%;
              background-color: #888;
              margin-right: 4px;
            }

            .txt {
              font-size: 12px;
              color: #888888;
              line-height: 20px;

              span {
                font-weight: 600;
                color: #0248ff;
              }
            }
          }
        }
      }

      .body {
        .sub_title {
          padding: 10px 0 10px;
          text-align: left;
          font-size: 12px;
          color: #0248ff;
          font-weight: bold;
        }
      }

      .close_icon {
        position: absolute;
        right: 8px;
        top: 8px;
        width: 8px;
        height: 8px;
        background: url("../static/job/close.png") center/cover no-repeat;
      }
    }
  }

  /deep/.el-table {
    border: none;
    font-size: 12px;

    td {
      border: none;
    }

    .el-table__cell {
      padding: 4px 0;
    }
  }

  /deep/ .el-table::before,
  /deep/ .el-table::after {
    display: none;
  }
}

.txt_with_style{
  white-space: pre-line;
}
</style>
